import { OPTIMISTIC_MANUAL_ROW_ID_PREFIX } from "@/payroll/ai-script/spreadsheet-cache";
import type {
  IAiSpreadsheetCell,
  CachedSpreadsheetCell,
  IAiSpreadsheetPasteEdit,
} from "@/payroll/ai-script/types";

export type BufferedManualRowEdit = Omit<IAiSpreadsheetPasteEdit, "cell_id"> & {
  col: number;
};

export const isOptimisticManualCell = (cell: IAiSpreadsheetCell): boolean =>
  (cell.manual_row_id ?? cell.id ?? "").startsWith(
    OPTIMISTIC_MANUAL_ROW_ID_PREFIX,
  );

export const isBufferedOptimisticManualCell = (
  cell: IAiSpreadsheetCell,
): boolean =>
  isOptimisticManualCell(cell) &&
  cell.source_ref?.editable_while_pending === true;

export const optimisticManualCellBelongsTo = (
  cell: CachedSpreadsheetCell,
  token: string,
): boolean =>
  (cell.optimistic_cell_id ?? cell.manual_row_id ?? cell.id).startsWith(
    `${OPTIMISTIC_MANUAL_ROW_ID_PREFIX}${token}-`,
  );

export const resolveBufferedManualRowEdits = ({
  cells,
  manualRowId,
  edits,
}: {
  cells: IAiSpreadsheetCell[];
  manualRowId: string;
  edits: BufferedManualRowEdit[];
}): IAiSpreadsheetPasteEdit[] => {
  const cellsByColumn = new Map(
    cells
      .filter((cell) => cell.manual_row_id === manualRowId)
      .map((cell) => [cell.col, cell]),
  );

  return edits.flatMap(({ col, ...edit }) => {
    const cell = cellsByColumn.get(col);
    return cell ? [{ ...edit, cell_id: cell.id }] : [];
  });
};
